import { render } from "./SelectedPlan.vue?vue&type=template&id=72bfe96f&scoped=true"
import script from "./SelectedPlan.vue?vue&type=script&lang=js"
export * from "./SelectedPlan.vue?vue&type=script&lang=js"

import "./SelectedPlan.vue?vue&type=style&index=0&id=72bfe96f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bfe96f"]])

export default __exports__